/**
 * Bundle 164 hotfix F3 - Relative time helper.
 *
 * Small `Just now / Nm ago / Nh ago / Nd ago / Nw ago /
 * absolute date` formatter. Consumed by the incomplete-
 * profiles listing for the Signup / V1 / V2 / Delete
 * columns. Returns "-" for a null / unparsable input so the
 * cells fall back to the same visual as before.
 */
export function formatRelativeTime(iso) {
  if (!iso) return '-';
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return '-';
  const now = Date.now();
  const seconds = Math.max(0, Math.floor((now - then) / 1000));
  if (seconds < 60) return 'Just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 14) return `${days}d ago`;
  const weeks = Math.floor(days / 7);
  if (weeks < 8) return `${weeks}w ago`;
  // 2+ months: absolute month + year to avoid awkward
  // "12w ago" or "9 months ago" phrasing.
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      month: 'short', year: 'numeric',
    });
  } catch (_) {
    return '-';
  }
}

/**
 * True when the ISO timestamp is within the last 24h. Used
 * by the V1 / V2 send-guard cooldown (mirrors Bundle 161
 * server-side check).
 */
export function isWithin24hCooldown(iso) {
  if (!iso) return false;
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return false;
  return (Date.now() - then) < 24 * 60 * 60 * 1000;
}
